'use client';

import { createContext } from 'react';

import { LocaleID, PlatformID, SubjectID } from '@common/clients/api/types.gen';
import { type ResolvedContextData } from '@common/defaults/ContextData';
import { ThemeID } from '@common/types/ThemeID';

export const NextContext = createContext<Readonly<ResolvedContextData>>({
    allowAds: true,
    allowExternalSnippets: true,
    allowBetting: true,
    allowPremium: false,
    allowMyPXR: true,
    allowTracking: true,
    contexts: [],
    env: {},
    hostname: '',
    isPlatformContext: false,
    context: {
        id: 0,
        locale: LocaleID.EN,
        platform: PlatformID.VP,
        slug: '',
        subject: SubjectID.FOOTBALL,
        url: '',
        name: '',
        nameSimple: '',
        twitter: '',
        facebook: '',
        instagram: '',
        tiktok: '',
        youtube: '',
        address: '',
    },
    platform: {
        id: PlatformID.VP,
        name: '',
        subject: SubjectID.FOOTBALL,
        jwplayerKey: '',
    },
    config: {
        api: {
            host: '',
            timeout: 0,
        },
        socket: {
            host: '',
            timeout: 0,
        },
        crossPlatform: {},
        captchaConfig: {
            siteKey: '',
        },
    },
    themeID: ThemeID.VP,
    topLevelCategories: false,
    topLevelPages: false,
    topLevelTags: false,
});
